<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Correio interno</span>
      </h1>
    </div>
  </div>

  <div v-if="message.id" class="align p-4 space_title">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="p-4">
              <div class="row">
                <div class="col-12 mb-2">
                  <div class="d-flex align-items-center justify-content-between">
                    <h5 class="mb-0">{{ message.title }}</h5>
                    <i @click="toggleFavorite" class="fa-star favorite-star" :class="message.favorite ? 'fa-solid favorited' : 'fa-regular'"></i>
                  </div>
                  <p class="date">{{ $dateFormat(message.created_at) }}</p>
                </div>

                <div class="col-12" id="message">
                  <p class="mb-0" v-html="message.content.replace(/\n/g, '<br>')"></p>
                </div>
              </div>
          </div>
        </div>
    </div>
  </div>

  </div>
</template>
  
<script setup>
import RedirectBack from '@/components/RedirectBack.vue'
import { useMessageStore } from '@/stores/MessageStore'
import { inject, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useToast, TYPE } from "vue-toastification";

const loader = inject('$loader');
const toast = useToast();

const messageStore = useMessageStore();
const { message } = storeToRefs(messageStore);

const route = useRoute();

async function toggleFavorite() {
  const result = await messageStore.toggleFavorite(message.value.id);
  if (result && result.success) {
    toast(message.value.favorite ? 'Mensagem favoritada' : 'Mensagem desfavoritada', { type: TYPE.SUCCESS, timeout: 6000 });
  }
}

onMounted(async () => {
  messageStore.message = {};

  const id = route.params.id;
  if(id){
    loader.show();
    await messageStore.getMessage(id);
    loader.hide();
  }
});
</script>

<style scoped>
.date {
  color: #747474;
}

.dark .date {
  color: #a2a6be;
}

.favorite-star {
  cursor: pointer;
  font-size: 1.2rem;
  color: #c0c0c0;
  transition: color 0.2s;
}

.favorite-star.favorited {
  color: #f5b301;
}

.favorite-star:hover {
  color: #f5b301;
}
</style>